import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../Config';

function VerifyOtp() {
    const navigate = useNavigate();
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const user = JSON.parse(localStorage.getItem("pendingUser"));
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/verify-whatsapp-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            otp: otp,
            // email: user.email,
            whatsapp_number: user.whatsapp_number,
            // username: user.username, 
          }),
        });
        const data = await response.json();
        if (data.status === 1) {
          localStorage.setItem("token", data.token);
          localStorage.removeItem("pendingUser");
          navigate("/");
          // Redirect to dashboard
        } else {
          setError(data.error);
          setLoading(false);
        }
      } catch (error) {
        setError("Failed to verify OTP");
        setLoading(false);
      }
    };
    return (
      <div>
          <div>
            <div className="home_three_container">        
            <div>
              {/*breadcrumbs area start*/}
              <div className="breadcrumbs_area">
                <div className="container">   
                  <div className="row">
                    <div className="col-12">
                      <div className="breadcrumb_content">
                        <h3>Verify OTP</h3>
                        <ul>
                          <li><a href="/">home</a></li>
                          <li>Verify OTP</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>         
              </div>
              {/*breadcrumbs area end*/}
              {/* customer login start */}
              <div className="customer_login">
                <div className="container">
                  <div className="row">
                    {/*login area start*/}
                    <div className="col-lg-6 col-md-6">
                      <div className="account_form">
                        <h2>Verify OTP</h2>
                        <h5>Please check your Email for OTP. {user.email}</h5>
                         {/* error box */}
                          {error && (
                            <div style={{ background: "#ffe6e6",  color: "#cc0000", padding: "10px", borderRadius: "6px", marginBottom: "15px", fontWeight: "500", }}>
                              {error}
                            </div>
                          )}
                        <form onSubmit={handleSubmit}>
                          <p>   
                            <label>OTP <span>*</span></label>
                            <input type="number" placeholder="Enter OTP" value={otp} onChange={(e) => setOtp(e.target.value)}/>
                          </p>
                         
                          <div className="login_submit">
                            <div className="login_submit">
                              <button type="submit" disabled={loading}>
                                {loading ? "Verifying OTP..." : "Verify OTP"}
                              </button>
                            </div>

                          </div>
                        </form>
                      </div>    
                    </div>
                  
                  </div>
                </div>    
              </div>
            </div>
            </div>

          </div>
        </div>
    );
}

export default VerifyOtp;